import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../../data/store'
import { getNetworkResponseError, isStatusOK } from '../../util/utill'
import { APIEndPoints } from '../APIEndPoints'
import { sitConfig } from '../config'
import { sendEventApi } from '../sendEvent'

const responseParser = (data: any) => {
  if (isStatusOK(data)) {
    return data?.data
  } else {
    throw getNetworkResponseError(data?.data)
  }
}

const customHeader = (tokens: any) => {
  const sitToken = sitConfig(tokens)
  return sitToken
}

export const doesBeneficiaryWithSameAccountExist = (
  tokens: any,
  remitterId: string,
  beneAccountNumber: string,
  beneIfscCode: string,
) => {
  const config = customHeader(tokens)
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier

  const request: Request<{}> = {
    apiPath: `${APIEndPoints.doesBeneficiaryWithSameAccountExist}?remitterid=${remitterId || RootStore?.customerDetails?.newRemittanceUserId}&accountnumber=${beneAccountNumber}&ifsccode=${beneIfscCode}`,
    method: 'GET',
    config,
  }
  sendEventApi(tokens, request, {
    status: 'INITIATED',
  })
  return executeRequest(request)
    .then((data) => {
      return responseParser(data)
    })
    .then((response) => {
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      throw err
    })
}
